<footer class="text-right privacy_footer">
    <div class="policy_center_div">
      <a (click)="openDialog('https://admin.goaudits.com/assets/Terms_of_Service.html')" target="blank" style="color: #49a487;cursor: pointer;">{{"Terms and Conditions" | translate}}</a>
      <a (click)="openDialog('https://admin.goaudits.com/assets/GoAudits_Privacy_Policy.html')" style="color: #49a487;cursor: pointer;">{{"Privacy Policy" | translate}}</a>
      <span>© GoAudits. {{"All Rights Reserved" | translate}}.</span>
    </div>

  </footer>
